var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "APP Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.56,
    y1: 16.63,
    x2: 38.97,
    y2: 16.77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.32,35.17a9.81,9.81,0,0,0,.11-1.09,9.65,9.65,0,0,0,0-1.08l2.4-1.78a.57.57,0,0,0,.15-.71L46.8,26.59a.54.54,0,0,0-.67-.25l-2.8,1a8.52,8.52,0,0,0-1.85-1.14l-.34-3a.57.57,0,0,0-.55-.48l-4.45-.12a.55.55,0,0,0-.56.45l-.5,2.94a8.66,8.66,0,0,0-1.91,1.05l-2.74-1.19a.55.55,0,0,0-.68.22L27.42,30a.57.57,0,0,0,.12.72l2.3,1.9a7.6,7.6,0,0,0-.11,1.08,9.83,9.83,0,0,0,.05,1.09l-2.39,1.78a.56.56,0,0,0-.16.71l2.13,3.91a.55.55,0,0,0,.67.26l2.8-1a8,8,0,0,0,1.86,1.15l.34,3a.56.56,0,0,0,.54.48l4.45.12a.57.57,0,0,0,.56-.46l.49-2.94a7.85,7.85,0,0,0,1.91-1l2.75,1.19a.56.56,0,0,0,.68-.23l2.33-3.79a.57.57,0,0,0-.12-.72ZM38,37.76A3.9,3.9,0,1,1,42,34,3.89,3.89,0,0,1,38,37.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.65,45.3l0,9.38a1.85,1.85,0,0,1-1.87,1.85l-23.68-.12a1.86,1.86,0,0,1-1.85-1.87l0-7.59V42.53l.16-30.27a1.88,1.88,0,0,1,1.88-1.85L37,10.54a1.87,1.87,0,0,1,1.86,1.87l-.06,10.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.22,
    y1: 50.04,
    x2: 38.63,
    y2: 50.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21,
    y1: 53.03,
    x2: 28.83,
    y2: 53.07
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.83,
    y1: 13.63,
    x2: 28.22,
    y2: 13.66
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppSettings01);
export default __webpack_public_path__ + "static/media/APP_Settings_01.811d57f8005a843331b57d903ed30c8c.svg";
export { ForwardRef as ReactComponent };